import React, { useEffect, useState } from "react";
import { Container, TextField, Typography, Box } from "@mui/material";
import { ButtonWrapper, PaperWrapper } from "./styledLoginComponents";
import { axiosInstance } from "configs/axios";
import { Navigate, useNavigate } from "react-router-dom";
import { authApiURL } from "API/urls/auth.api";
import { useDispatch, useSelector } from "react-redux";

import { getCookieDetails } from "Auth/authActions";
import { setLoginFlag } from "features/auth/authSlice";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (getCookieDetails()) {
      dispatch(setLoginFlag(true));
    }
  }, []);
  const isUserAuthenticated = useSelector(
    (state) => state?.auth?.isAuthenticated
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(authApiURL.login, {
        username,
        password,
      });
      if (response.status === STATUS_CODES.SUCCESS) {
        navigate("/");
      }
      throw new Error(response?.data?.message);
    } catch (error) {
      setError(error.response?.data?.message);
    }
  };

  return isUserAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <Container component="main" maxWidth="xs">
      <PaperWrapper elevation={4}>
        <Typography variant="h5">Login</Typography>
        <FlexBox justifyContent={"center"}>
          <img
            src="https://ievo.in/wp-content/uploads/2020/07/logo-color-ievo.png"
            alt="IEVO"
          />
        </FlexBox>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          {error && <Typography color="error">{error}</Typography>}
          <TextField
            label="User Name"
            type="text"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <ButtonWrapper type="submit" fullWidth variant="contained">
            Login
          </ButtonWrapper>
        </Box>
      </PaperWrapper>
    </Container>
  );
};
